import React, { FC, useContext, useEffect } from 'react';
import meuConsumptionContext from '../../../../../contexts/MeuConsumptionContext';
import { billingRoutes } from '../../../../../routes/BillingRoutes';
import MeuConsumptionMonthlyUsage from '../../../MeuConsumption/components/MeuConsumptionMonthlyUsage';
import { MeuConsumptionContainer } from '../../styles';

const MonthlyUsageComponent: FC = () => {
  const { content, dateToSearch, tenant, setHeaderContent } = useContext(meuConsumptionContext);
  useEffect(() => {
    setHeaderContent({
      redirect: billingRoutes.meuConsumption,
      text: content.formatString(content.header, tenant.info.name),
    });

    return () => setHeaderContent({ redirect: '/' });
  }, [dateToSearch]);

  return (
    <MeuConsumptionContainer>
      <MeuConsumptionMonthlyUsage isDetailedView />
    </MeuConsumptionContainer>
  );
};

export default MonthlyUsageComponent;
